import { useState } from "react";

import { globalLogin } from "../auth/authApiLocalClient";
import { loginWithPasskey } from "../auth/webauthnClient";

// Only Russia for now, matching kwms-web's own PhoneLoginForm.
const DIAL_CODE = "+7";

interface PasskeyLoginFormProps {
  onLoggedIn: () => void;
}

/**
 * Телефон + passkey only -- a *repeat* login for someone who already
 * enrolled a passkey through the QR flow's own offer step
 * (OfferPasskeyStep.tsx), same shape as kwms-web's own PhoneLoginForm.
 * Doesn't depend on a phone being present to scan a QR with, unlike the
 * QR flow above it.
 */
export function PasskeyLoginForm({ onLoggedIn }: PasskeyLoginFormProps) {
  const [nationalNumber, setNationalNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const isPhoneValid = nationalNumber.replace(/\D/g, "").length === 10;
  const phone = DIAL_CODE + nationalNumber.replace(/\D/g, "");

  async function loginByPasskey() {
    if (isLoading || !isPhoneValid) return;
    setIsLoading(true);
    setError(null);
    try {
      const tokens = await loginWithPasskey(phone);
      const admitted = await globalLogin(tokens.accessToken);
      if (!admitted) {
        setError("Нет доступа к этому кабинету");
        return;
      }
      onLoggedIn();
    } catch (e) {
      setError(e instanceof Error ? e.message : "Не удалось войти по ключу доступа");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <div className="field">
        <label className="field-label" htmlFor="phone-input">
          Номер телефона
        </label>
        <div className="input-prefix-group">
          <span className="input-prefix">{DIAL_CODE}</span>
          <input
            id="phone-input"
            className="input"
            type="tel"
            value={nationalNumber}
            onChange={(e) => setNationalNumber(e.target.value)}
            placeholder="911 000-00-00"
            disabled={isLoading}
          />
        </div>
      </div>
      <button className="btn btn-secondary" style={{ width: "100%" }} onClick={loginByPasskey} disabled={isLoading || !isPhoneValid}>
        {isLoading ? "Входим…" : "Войти по ключу доступа"}
      </button>
      {error && <p className="error-text" role="alert">{error}</p>}
    </div>
  );
}
